(function () {
    'ngInject';

    angular.module('app.shared.services').factory('FontAPIService', fontAPIService);

    function fontAPIService(HttpService) {
        function getFonts() {
            var url = '/Font/GetFonts';
            return HttpService.get(url);
        }

        function deleteFont(fontName) {
            const url = '/Font/' + encodeURIComponent(fontName);
            return HttpService.delete(url);
        }

        function getFontUploadSignedUrl(filename) {
            const url = '/Font/FontUploadSignedUrl/' + encodeURIComponent(filename);
            return HttpService.get(url);
        }

        function validateFont(filename) {
            const url = '/Font/Validate/' + encodeURIComponent(filename);
            return HttpService.get(url);
        }

        return {
            getFonts: getFonts,
            deleteFont: deleteFont,
            getFontUploadSignedUrl: getFontUploadSignedUrl,
            validateFont: validateFont
        };
    }
})();
